import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["inputModal", "confirmModal", "form"]
  static values = {
    remaining: Number,
    limit: Number
  }

  connect() {
    this._handleEscape = this._closeOnEscape.bind(this)
    this._handleOpen = this.openInput.bind(this)
    document.addEventListener("keydown", this._handleEscape)
    window.addEventListener("open-regeneration-modal", this._handleOpen)
  }

  disconnect() {
    document.removeEventListener("keydown", this._handleEscape)
    window.removeEventListener("open-regeneration-modal", this._handleOpen)
    document.body.classList.remove("overflow-hidden")
  }

  openInput(event) {
    if (event && event.preventDefault) event.preventDefault()
    this.inputModalTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
  }

  closeInput(event) {
    // Only close if clicking the backdrop itself, not a child element
    if (event && event.target !== event.currentTarget) return
    if (event) event.preventDefault()
    this.inputModalTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
  }

  closeInputButton(event) {
    if (event) event.preventDefault()
    this.inputModalTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
  }

  showConfirmation(event) {
    if (event) event.preventDefault()
    this.inputModalTarget.classList.add("hidden")
    this.confirmModalTarget.classList.remove("hidden")
  }

  backToInput(event) {
    if (event) event.preventDefault()
    this.confirmModalTarget.classList.add("hidden")
    this.inputModalTarget.classList.remove("hidden")
  }

  confirm(event) {
    if (event) event.preventDefault()
    this.confirmModalTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
    this.formTarget.requestSubmit()
  }

  closeAll(event) {
    // Only close if clicking the backdrop itself, not a child element
    if (event && event.target !== event.currentTarget) return
    if (event) event.preventDefault()
    this.inputModalTarget.classList.add("hidden")
    this.confirmModalTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
  }

  _closeOnEscape(event) {
    if (event.key !== "Escape") return

    if (!this.confirmModalTarget.classList.contains("hidden")) {
      this.confirmModalTarget.classList.add("hidden")
      this.inputModalTarget.classList.remove("hidden")
    } else if (!this.inputModalTarget.classList.contains("hidden")) {
      this.inputModalTarget.classList.add("hidden")
      document.body.classList.remove("overflow-hidden")
    }
  }
}
